/**
 * eslint-disable react/jsx-filename-extension
 *
 * @format
 */

// material
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import componentsOverride from './overrides';
//
import palette from './palette';
import shadows, { customShadows } from './shadows';
import typography from './typography';

// ----------------------------------------------------------------------

function ThemeProvider({ children }) {
  const themeOptions = useMemo(
    () => ({
      palette,
      shape: { borderRadius: 12 },
      typography,
      shadows,
      customShadows,
    }),
    [],
  );

  const theme = useMemo(() => {
    const nextTheme = createTheme(themeOptions);
    nextTheme.components = componentsOverride(nextTheme);
    return nextTheme;
  }, [themeOptions]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

ThemeProvider.defaultProps = {
  children: undefined,
};

export { ThemeProvider };
